import { Typography } from '@material-ui/core';
import PriorityHighIcon from '@material-ui/icons/PriorityHigh';

import Moment from 'moment';
import { format, differenceInMonths } from 'date-fns';

import MFab from './@material-extend/MFab';
import MChip from './@material-extend/MChip';
import { PageActivity, CompanyAuthorize } from './DataConstant';

export function getDataFromAutoComplete(val) {
  return val ? (val.length > 0 ? val.map((x) => x.value).join(',') : val.value) : '';
}

export function getDataFromAutoCompleteBool(val) {
  return val === null ? null : val.value;
}

export function setTotalGroupTab(data, label) {
  let cnt = 0;
  if (data && data.length) {
    cnt = data.length;
  }
  return (
    <span>
      {label}
      &nbsp;&nbsp;&nbsp;
      {data && data.length > 0 ? <MChip label={`Result ${toFixed(cnt, 0)}  Groups`} color="info" /> : null}
    </span>
  );
}

export function setTotalRecordsTab(data, label) {
  let cnt = 0;
  if (data && data.length) {
    cnt = data.length;
    // data.forEach((x) => {
    //   if (x.children !== null && x.children !== undefined) {
    //     cnt += x.children.length;
    //   } else {
    //     cnt += 1;
    //   }
    // });
  }
  return (
    <span>
      {label}
      &nbsp;&nbsp;&nbsp;
      {data && data.length > 0 ? <MChip label={`Result ${toFixed(cnt, 0)}  Groups`} color="info" /> : null}
    </span>
  );
}

export function setTotalRecords(data) {
  let cnt = 0;
  if (data && data.length) {
    cnt = data.length;
    // data.forEach((x) => {
    //   if (x.children !== null && x.children !== undefined) {
    //     cnt += x.children.length;
    //   } else {
    //     cnt += 1;
    //   }
    // });
  }
  return (
    <span>
      {'  '}
      {data && data.length > 0 ? <MChip label={`Result ${toFixed(cnt, 0)}  Groups`} color="info" /> : null}
    </span>
  );
}

export function setStatusDocument(status) {
  const statusLower = (status || '').toLowerCase();
  if (['completed', 'completedsystem', 'completed (by system)'].indexOf(statusLower) >= 0) return 'success2';
  if (['inactive'].indexOf(statusLower) >= 0) return 'error';
  if (['pending wh'].indexOf(statusLower) >= 0) return 'warning';
  if (['pending logistic'].indexOf(statusLower) >= 0) return 'info';
  if (['pending credit'].indexOf(statusLower) >= 0) return 'info';
  if (['already sent'].indexOf(statusLower) >= 0) return 'success3';
  return 'default';
}

export function setInvoiceDocumentStatus(status) {
  const statusLower = (status || '').toLowerCase();
  if (['completed', 'completedsystem', 'completed (by system)'].indexOf(statusLower) >= 0) return 'success2';
  if (['waiting'].indexOf(statusLower) >= 0) return 'warning';
  return 'default';
}

export function setStatusOutsource(status) {
  const statusLower = (status || '').toLowerCase();
  let color = 'default';
  if (['new'].indexOf(statusLower) >= 0) color = 'warning';
  if (['already sent'].indexOf(statusLower) >= 0) color = 'success3';
  if (['completed', 'completedsystem', 'completed (by system)'].indexOf(statusLower) >= 0) color = 'success2';
  if (['confirmed'].indexOf(statusLower) >= 0) color = 'info';
  return status ? <MChip label={status} color={color} /> : null;
}
export function setStatusDialog(status) {
  const statusLower = (status || '').toLowerCase();
  if (['new'].indexOf(statusLower) >= 0) return 'warning';
  if (['already sent'].indexOf(statusLower) >= 0) return 'success3';
  if (['completed', 'completedsystem', 'completed (by system)'].indexOf(statusLower) >= 0) return 'success2';
  if (['confirmed'].indexOf(statusLower) >= 0) return 'info';
  return 'default';
}

export function setStatusGLStatement(status) {
  const statusLower = (status || '').toLowerCase();
  let color = 'default';
  if (['incoming payment'].indexOf(statusLower) >= 0) color = 'success2';
  if (['confirm'].indexOf(statusLower) >= 0) color = 'info';
  return status ? <MChip label={status} color={color} /> : null;
}

export function setCallingPayment(status) {
  const statusLower = (status || '').toLowerCase();
  let color = 'default';
  if (['yes'].indexOf(statusLower) >= 0) color = 'error';
  else if (['no'].indexOf(statusLower) >= 0) color = 'info';
  return status ? <MChip key={status} label={status} color={color} /> : null;
}
export function setOverallStatusPO(status) {
  const statusLower = (status || '').toLowerCase();
  let color = 'default';
  if (['being processed'].indexOf(statusLower) >= 0) color = 'default';
  else if (['completed', 'completedsystem', 'completed (by system)'].indexOf(statusLower) >= 0) color = 'success2';
  else if (['in process'].indexOf(statusLower) >= 0) color = 'warning';
  else if (['may not occur'].indexOf(statusLower) >= 0) color = 'warning2';
  else if (['open'].indexOf(statusLower) >= 0) color = 'error';
  return status ? <MChip key={status} label={status} color={color} /> : null;
}
export function setPOStatus(status) {
  const statusLower = (status || '').toLowerCase();
  let color = 'default';
  if (['po header not found', 'po item not found'].indexOf(statusLower) >= 0) color = 'default';
  else if (['ready to download'].indexOf(statusLower) >= 0) color = 'success2';
  else if (['reload all'].indexOf(statusLower) >= 0) color = 'warning';
  else if (['only po header', 'only po item'].indexOf(statusLower) >= 0) color = 'warning2';
  else if (['file not found'].indexOf(statusLower) >= 0) color = 'error';
  return status ? <MChip key={status} label={status} color={color} /> : null;
}
export function setStatusCallingPayment(status) {
  const statusLower = (status || '').toLowerCase();
  let color = 'default';
  if (['open'].indexOf(statusLower) >= 0) color = 'info';
  if (['waiting os confirm', 'waiting bu confirm'].indexOf(statusLower) >= 0) color = 'warning';
  else if (['no'].indexOf(statusLower) >= 0) color = 'default';
  else if (['confirm os', 'confirm bu', 'confirm payment'].indexOf(statusLower) >= 0) color = 'success2';
  return status ? <MChip key={status} label={status} color={color} /> : null;
}
export function setStatusBill(status) {
  const color = 'default';
  return status ? <MChip key={status} label={status} color={color} /> : null;
}

export function setStatusOverdue(status) {
  const color = 'default';
  return status ? <MChip key={status} label={status} color={color} /> : null;
}

export function setStatusPayment(status, text, id) {
  const statusLower = (status || '').toLowerCase();
  let color = 'default';
  if (['open'].indexOf(statusLower) >= 0) color = 'warning';
  else if (['waiting for confirm (eot)'].indexOf(statusLower) >= 0) color = 'warning2';
  else if (['waiting credit advice'].indexOf(statusLower) >= 0) color = 'warning3';
  else if (['waiting confirm credit advice'].indexOf(statusLower) >= 0) color = 'warning4';
  else if (['confirm payment'].indexOf(statusLower) >= 0) color = 'info';
  else if (['incoming payment'].indexOf(statusLower) >= 0) color = 'secondary';
  else if (['payment success'].indexOf(statusLower) >= 0) color = 'success';
  else if (['cancelled'].indexOf(statusLower) >= 0) color = 'default';
  else if (['failed', 'unconfirm (eot)'].indexOf(statusLower) >= 0) color = 'error';
  return status && text ? (
    <MChip
      key={status}
      label={text}
      color={color}
      onClick={() => {
        if (id) window.open(`/dashboard/payment-management/incoming-payment/matching/${id}`);
      }}
    />
  ) : null;
}

export function setTransactionIncomingExport(status, row) {
  const statusLower = (status || '').toLowerCase();
  let color = 'default';
  if (['open'].indexOf(statusLower) >= 0) color = 'warning';
  else if (['waiting for confirm (eot)'].indexOf(statusLower) >= 0) color = 'warning2';
  else if (['waiting credit advice'].indexOf(statusLower) >= 0) color = 'warning3';
  else if (['waiting confirm credit advice'].indexOf(statusLower) >= 0) color = 'warning4';
  else if (['confirm payment'].indexOf(statusLower) >= 0) color = 'info';
  else if (['incoming payment'].indexOf(statusLower) >= 0) color = 'secondary';
  else if (['payment success'].indexOf(statusLower) >= 0) color = 'success';
  else if (['cancelled'].indexOf(statusLower) >= 0) color = 'default';
  else if (['failed', 'unconfirm (eot)'].indexOf(statusLower) >= 0) color = 'error';
  return status ? (
    <MChip
      key={status}
      label={row.transactionNo}
      color={color}
      onClick={() => window.open(`/dashboard/export-payment/export-incoming-payment-manual/${row.bankInwardId}`)}
    />
  ) : null;
}

export function setOverallStatus(status) {
  let color = 'default';
  const statusLower = (status || '').toLowerCase();
  if (['waiting matching', 'incoming payment'].indexOf(statusLower) >= 0) color = 'warning';
  else if (['completed (paid)', 'completed (paid) by system'].indexOf(statusLower) >= 0) color = 'success2';
  else if (['cancelled'].indexOf(statusLower) >= 0) color = 'error';
  return status ? <MChip key={status} label={status} color={color} /> : null;
}
export function setStatusConverAndCalling(status) {
  let color = 'default';
  const statusLower = (status || '').toLowerCase();
  if (['yes'].indexOf(statusLower) >= 0) color = 'success';
  else if (['no'].indexOf(statusLower) >= 0) color = 'error';
  return status ? <MChip key={status} label={status} color={color} /> : null;
}
export function toStatusPlanCash(status) {
  let color = 'default';
  const statusLower = (status || '').toLowerCase();
  if (['wait for confirm'].indexOf(statusLower) >= 0) color = 'warning';
  if (['confirmed'].indexOf(statusLower) >= 0) color = 'success2';
  return status ? <MChip key={status} label={status} color={color} /> : null;
}
export function setStatus2(status, isHasCancelInv) {
  let color = 'default';
  const statusLower = (status || '').toLowerCase();
  if (isHasCancelInv === true) return 'error';
  if (['active', 'completed', 'completedsystem', 'completed (by system)', 'success'].indexOf(statusLower) >= 0)
    color = 'success2';
  if (['inactive'].indexOf(statusLower) >= 0) return 'error';
  if (['waiting to create', 'waiting'].indexOf(statusLower) >= 0) color = 'warning';
  if (['waitingcreate', 'waiting'].indexOf(statusLower) >= 0) color = 'warning';
  if (['waiting to send os', 'waiting to send customer'].indexOf(statusLower) >= 0) color = 'info';
  return status ? <MChip key={status} label={status} color={color} /> : null;
}

export function setStatus(status, isHasCancelInv) {
  const statusLower = (status || '').toLowerCase();
  if (isHasCancelInv === true) return 'error';
  if (['active', 'completed', 'completedsystem', 'completed (by system)', 'success'].indexOf(statusLower) >= 0)
    return 'success2';
  if (['inactive'].indexOf(statusLower) >= 0) return 'error';
  if (['waiting to create', 'waiting'].indexOf(statusLower) >= 0) return 'warning';
  if (['waitingcreate', 'waiting'].indexOf(statusLower) >= 0) return 'warning';
  if (['waiting to send os', 'waiting to send customer'].indexOf(statusLower) >= 0) return 'info';
  return 'default';
}

export function setStatusBU(status) {
  const statusLower = (status || '').toLowerCase();
  if (['completed', 'completedsystem', 'completed (by system)'].indexOf(statusLower) >= 0) return 'success2';
  if (['new'].indexOf(statusLower) >= 0) return 'warning';
  if (['confirmed'].indexOf(statusLower) >= 0) return 'info';
  if (['alreadysend', 'already sent', 'alreadysent'].indexOf(statusLower) >= 0) return 'success3';
  return 'default';
}
export function setStatusEmail(status) {
  const statusLower = (status || '').toLowerCase();
  if (['completed', 'completedsystem', 'completed (by system)'].indexOf(statusLower) >= 0) return 'success2';
  if (['new'].indexOf(statusLower) >= 0) return 'warning';
  if (['confirmed'].indexOf(statusLower) >= 0) return 'info';
  if (['alreadysend', 'already sent', 'alreadysent'].indexOf(statusLower) >= 0) return 'success3';
  return 'default';
}

export function setStatusEMS(status) {
  const statusLower = (status || '').toLowerCase();
  if (['completed', 'completedsystem', 'completed (by system)'].indexOf(statusLower) >= 0) return 'success2';
  if (['new'].indexOf(statusLower) >= 0) return 'warning';
  if (['confirmed'].indexOf(statusLower) >= 0) return 'info';
  if (['alreadysend', 'already sent', 'alreadysent'].indexOf(statusLower) >= 0) return 'success3';
  return 'default';
}

export function toNumber(number, float = 2) {
  if (number >= 0 || !number) return toFixed(number, float);
  number = Math.abs(number);
  return `(${toFixed(number, float)})`;
}

export function toFixed(number, digit = 3, noComma = false, noFixZero = false) {
  if (number === null || number === undefined) return null;
  if (isNaN(number)) number = 0;
  // if (number === 0) return '0';
  let rounded = 0;

  if (noFixZero) {
    const s = number.toString().split('.');
    if (s[1] && s[1].length > digit) {
      rounded = toFixedNumber(number, digit);
    } else {
      rounded = Number(number);
    }
  } else rounded = toFixedNumber(number, digit);

  let parts = rounded.toFixed(digit).split('.');
  if (noFixZero) parts = rounded.toString().split('.');

  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  if (noComma) return parts.join('.').replace(/,/g, '');
  return parts.join('.');
}

export function compareString(a, b) {
  if (a === null || a === undefined) a = '';
  if (b === null || b === undefined) b = '';
  return a.toString().localeCompare(b.toString());
}

export function compareDate(a, b) {
  if (!a && !b) return 0;
  else if (!a) return 1;
  else if (!b) return -1;
  else {
    const ma = Moment(a);
    const mb = Moment(b);

    return ma.isBefore(mb) ? -1 : ma.isAfter(mb) ? 1 : 0;
  }
}

export function notNumber(a) {
  return a === null || a === undefined || a === '' || isNaN(a) || typeof a === 'boolean';
}

export function compareNumber(a, b) {
  let aNaN = false;
  let bNaN = false;
  if (notNumber(a)) aNaN = true;
  if (notNumber(b)) bNaN = true;

  if (aNaN && bNaN) return 0;
  else if (aNaN) return 1;
  else if (bNaN) return -1;
  else return Number(a) - Number(b);
}

export function toDateStr(date, formats) {
  Moment.locale('en');
  if (!date) return null;
  if (!formats) formats = 'DD/MM/YYYY';
  return Moment(date).format(formats);
}
export function toDateTimeStr(date, formats) {
  Moment.locale('en');
  if (!date) return null;
  if (!formats) formats = 'DD/MM/YYYY HH:mm';
  return Moment(date).format(formats);
}

export function toFixedNumber(number, float = 0) {
  if (float === null || float === '' || float === undefined) float = 0;
  if (isNaN(float)) float = 0;
  if (!number) return 0;
  if (isNaN(number)) return 0;

  number = Number(number);
  const div = 10 ** float;
  return Math.round(number * div) / div;
}

export function uniqueArray(arrArg) {
  return arrArg.filter((elem, pos, arr) => arr.indexOf(elem) === pos);
}

export function uniqueList(list) {
  const dataArr = list.map((item) => [JSON.stringify(item), item]);
  const maparr = new Map(dataArr);
  const result = [...maparr.values()];
  return result;
}

export function setStatusProblemReport(status) {
  const statusLower = (status || '').toLowerCase();
  if (['open', 'openpdc'].indexOf(statusLower) >= 0) return 'error';
  if (['cancelled'].indexOf(statusLower) >= 0) return 'default';
  if (['draft'].indexOf(statusLower) >= 0) return 'error';
  if (['partial'].indexOf(statusLower) >= 0) return 'info';
  if (['closed'].indexOf(statusLower) >= 0) return 'default';
  if (['closed1'].indexOf(statusLower) >= 0) return 'default';
  if (['closed2'].indexOf(statusLower) >= 0) return 'default';
  if (['generate'].indexOf(statusLower) >= 0) return 'warning';
  if (['waitingcreditadvice'].indexOf(statusLower) >= 0) return 'warning3';
  if (['waitingconfirmcreditadvice'].indexOf(statusLower) >= 0) return 'warning4';
  return 'default';
}

export function setStatusLateCharge(status) {
  const statusLower = (status || '').toLowerCase();
  if (['open', 'draft', 'reject'].indexOf(statusLower) >= 0) return 'error';
  if (['cancelled', 'cancel'].indexOf(statusLower) >= 0) return 'default';
  if (['on process'].indexOf(statusLower) >= 0) return 'info';
  if (['อนุมัติไม่เรียกเก็บ'].indexOf(statusLower) >= 0) return 'warning';
  if (['อนุมัติเรียกเก็บ'].indexOf(statusLower) >= 0) return 'primary';
  return 'default';
}

export function setStatusLateChargeApprove(status) {
  const statusLower = (status || '').toLowerCase();
  if (['created'].indexOf(statusLower) >= 0) return 'warning';
  if (['rejected', 'อนุมัติไม่เรียกเก็บ'].indexOf(statusLower) >= 0) return 'error';
  if (['cancelled', 'cancel'].indexOf(statusLower) >= 0) return 'default';
  if (['อนุมัติเรียกเก็บ', 'approved'].indexOf(statusLower) >= 0) return 'primary';
  return 'default';
}

export function setStatusApprove(status) {
  if (status === null) return null;
  let color = 'info';
  const statusLower = (status || '').toLowerCase();
  if (['rejected'].indexOf(statusLower) >= 0) color = 'error';
  if (['approved'].indexOf(statusLower) >= 0) color = 'primary';
  return <MChip label={`${status}`} color={color} />;
}

export function setStatusChequeReturn(status) {
  const statusLower = (status || '').toLowerCase();
  if (['open', 'draft'].indexOf(statusLower) >= 0) return 'error';
  if (['closed'].indexOf(statusLower) >= 0) return 'default';
  if (['partial'].indexOf(statusLower) >= 0) return 'info';
  if (['waitingunblock'].indexOf(statusLower) >= 0) return 'warning';
  if (['completed'].indexOf(statusLower) >= 0) return 'primary';
  return 'default';
}

export function setStatusUnblockOrder(status) {
  const statusLower = (status || '').toLowerCase();
  if (['open', 'rejected'].indexOf(statusLower) >= 0) return 'error';
  if (['closed'].indexOf(statusLower) >= 0) return 'default';
  if (['onprocess', 'on process', 'onprocessprint', 'on process(print)'].indexOf(statusLower) >= 0) return 'info';
  if (['waitingunblock', 'waiting unblock', 'withdraw'].indexOf(statusLower) >= 0) return 'warning';
  if (['completed'].indexOf(statusLower) >= 0 || statusLower.includes('approved')) return 'success2';
  return 'default';
}

export function openPdf(data) {
  if (data.base64File && data.base64File.length > 0) {
    const binaryString = window.atob(data.base64File); // Comment this if not using base64
    const bytes = new Uint8Array(binaryString.length);
    const bytes2 = bytes.map((byte, i) => binaryString.charCodeAt(i));
    const newBlob = new Blob([bytes2], {
      type: 'application/pdf'
    });
    const fileURL = URL.createObjectURL(newBlob);
    window.open(fileURL);
  } else if (data.size > 0) {
    const newBlob = new Blob([data], {
      type: 'application/pdf'
    });
    const fileURL = URL.createObjectURL(newBlob);
    window.open(fileURL);
  }
}

export function downloadFile(data, fileName, fileType = 'application/pdf') {
  let newBlob;
  if (data.base64File && data.base64File.length > 0) {
    const binaryString = window.atob(data.base64File); // Comment this if not using base64
    const bytes = new Uint8Array(binaryString.length);
    const bytes2 = bytes.map((byte, i) => binaryString.charCodeAt(i));
    newBlob = new Blob([bytes2], {
      type: fileType
    });
  } else if (data.size > 0) {
    newBlob = new Blob([data], {
      type: fileType
    });
  }

  const url = URL.createObjectURL(newBlob);
  const a = window.document.createElement('a');
  a.download = fileName || 'BillPresentment.pdf';
  a.style = 'display:none;';
  a.href = url;
  window.document.body.appendChild(a);
  a.click();
  URL.revokeObjectURL(url);
  a.remove();
}

export function setStatusInsurance(status) {
  const statusLower = (status || '').toLowerCase();
  if (['open'].indexOf(statusLower) >= 0) return 'error';
  if (['closed'].indexOf(statusLower) >= 0) return 'default';
  return 'default';
}

export function getPermission(page, action) {
  return true;
}
export function getDataFromDate(val) {
  return val === null || val === undefined ? null : format(val, "yyyy-MM-dd'T'HH:mm:ss'Z'");
}

export function getDataFromDateRange(val) {
  if (val && val.length > 0)
    return val.map((o) => (o !== null && o !== undefined ? format(o, "yyyy-MM-dd'T'HH:mm:ss'Z'") : null));

  return null;
}

export function setDate(date) {
  return date === null ? null : new Date(date);
}

export function downloadFileBase64(base64String, fileName) {
  const extensions = fileName.split('.');
  let mime = '';
  if (extensions.length === 1) {
    mime = getMIMEType('');
  } else {
    const extension = extensions[extensions.length - 1];
    mime = getMIMEType(extension);
  }

  const base64 = `data:${mime};base64,${base64String}`;

  const link = document.createElement('a');
  link.href = base64;
  link.download = fileName;
  link.click();
}

export function downloadFileExcel(data, fileName) {
  if (data.base64File && data.base64File.length > 0) {
    try {
      // Decode base64 to binary string
      const binaryString = window.atob(data.base64File);

      // Convert binary string to array buffer
      const len = binaryString.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; i += 1) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      // Create a blob from the array buffer
      const blob = new Blob([bytes], { type: 'application/vnd.ms-excel' });

      // Create a URL for the blob
      const url = URL.createObjectURL(blob);

      // Create an invisible anchor element
      const a = document.createElement('a');
      a.style.display = 'none';
      document.body.appendChild(a);

      // Set the anchor's href and download attributes, and trigger a click event
      a.href = url;
      a.download = fileName;
      a.click();

      // Clean up
      URL.revokeObjectURL(url);
      a.remove();
    } catch (error) {
      console.error('Error processing Excel file:', error);
    }
  } else {
    console.error('No data found in base64File.');
  }
}

export function getMIMEType(ex) {
  if (['txt'].includes(ex)) return 'text/plain';
  else if (['csv'].includes(ex)) return 'text/csv';
  else if (['html', 'htm'].includes(ex)) return 'text/html';
  else if (['css'].includes(ex)) return 'text/css';
  else if (['js'].includes(ex)) return 'text/javascript';
  else if (['json'].includes(ex)) return 'application/json';
  else if (['xml'].includes(ex)) return 'application/xml';
  else if (['pdf'].includes(ex)) return 'application/pdf';
  else if (['zip'].includes(ex)) return 'application/zip';
  else if (['rar'].includes(ex)) return 'application/x-rar-compressed';
  else if (['7z'].includes(ex)) return 'application/x-7z-compressed';
  else if ([''].includes(ex)) return 'application/octet-stream';
  else if (['jpeg', 'jpg'].includes(ex)) return 'image/jpeg';
  else if (['png'].includes(ex)) return 'image/png';
  else if (['gif'].includes(ex)) return 'image/gif';
  else if (['bmp'].includes(ex)) return 'image/bmp';
  else if (['tiff', 'tif'].includes(ex)) return 'image/tiff';
  else if (['svg'].includes(ex)) return 'image/svg+xml';
  else if (['webp'].includes(ex)) return 'image/webp';
  else if (['ico'].includes(ex)) return 'image/x-icon';
  else if (['mp3'].includes(ex)) return 'audio/mpeg';
  else if (['wav'].includes(ex)) return 'audio/wav';
  else if (['mp4'].includes(ex)) return 'video/mp4';
  else if (['mpeg', 'mpg'].includes(ex)) return 'video/mpeg';
  else if (['avi'].includes(ex)) return 'video/x-msvideo';
  else if (['mkv'].includes(ex)) return 'video/x-matroska';
  else if (['wmv'].includes(ex)) return 'video/x-ms-wmv';
  else if (['flv'].includes(ex)) return 'video/video/x-flv';
  else if (['webm'].includes(ex)) return 'video/webm';
  else if (['xlsx'].includes(ex)) return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  else if (['xls', 'xlt'].includes(ex)) return 'application/vnd.ms-excel';
  else if (['xlsm'].includes(ex)) return 'application/vnd.ms-excel.sheet.macroEnabled.12';
  else if (['xlsb'].includes(ex)) return 'application/vnd.ms-excel.sheet.binary.macroEnabled.12';
  else if (['xltm'].includes(ex)) return 'application/vnd.ms-excel.template.macroEnabled.12';
  else if (['pptx'].includes(ex)) return 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
  else if (['ppt', 'pot'].includes(ex)) return 'application/vnd.ms-powerpoint';
  else if (['pptm'].includes(ex)) return 'application/vnd.ms-powerpoint.presentation.macroEnabled.12';
  else if (['potx'].includes(ex)) return 'application/vnd.openxmlformats-officedocument.presentationml.template';
  else if (['potm'].includes(ex)) return 'application/vnd.ms-powerpoint.template.macroEnabled.12';
}

export function getMultipleList(data) {
  if (!data) return [];
  if (!data.trim()) return [];
  const newlist = [];

  data.split(',').map((m) => newlist.push({ value: m, title: m }));
  return newlist;
}

export function setHighlightOverdue(status) {
  const statusLower = (status || '').toLowerCase();
  if (!status) return null;
  if (statusLower === 'highlight') {
    return (
      <MFab color="error">
        <PriorityHighIcon />
      </MFab>
    );
  } else if (statusLower === 'new') {
    return <MChip key="New" label="New" color="warning" />;
  }
  return null;
}

export function setDocStatus(status) {
  const statusLower = (status || '').toLowerCase();
  if (['completed', 'completedsystem', 'completed (by system)'].indexOf(statusLower) >= 0) return 'success2';
  if (['waiting'].indexOf(statusLower) >= 0) return 'warning';
  return 'default';
}
export function toDocStatus(status, onClick) {
  const statusLower = (status || '').toLowerCase();
  if (!status) return null;
  let color = 'default';
  if (statusLower === 'noattach' || statusLower === 'no attach') status = 'No Attach';
  if (['waiting'].indexOf(statusLower) >= 0) color = 'warning';
  if (['completed', 'completedsystem', 'completed (by system)'].indexOf(statusLower) >= 0) color = 'success2';
  return <MChip key={status} label={status} color={color} onClick={onClick} />;
}

export function setHighlightOverdue2(status) {
  const statusLower = (status || '').toLowerCase();
  if (!status) return null;
  let color = 'default';
  if (['highlight'].indexOf(statusLower) >= 0) color = 'error';
  if (['new'].indexOf(statusLower) >= 0) color = 'warning';
  return <MChip key={status} label={status} color={color} />;
}
export function setRememberAction(status) {
  const statusLower = (status || '').toLowerCase();
  if (!status) return null;
  if (statusLower === 'yes') {
    return (
      <Typography variant="body1" color="red">
        Yes
      </Typography>
    );
  }
  return 'No';
}
export function toStatusActive(isActive) {
  let label = 'Active';
  let color = 'success2';
  if (!isActive) {
    label = 'Inactive';
    color = 'error';
  }
  return <MChip key={label} label={label} color={color} />;
}

export function setSendEmailStatus(status) {
  const statusLower = (status || '').toLowerCase();
  if (['sent'].indexOf(statusLower) >= 0) return 'success2';
  if (['failed'].indexOf(statusLower) >= 0) return 'error';
  if (['waiting'].indexOf(statusLower) >= 0) return 'warning';
  if (['sending'].indexOf(statusLower) >= 0) return 'info';
  return 'default';
}
export function getCompanyActivity(activity) {
  const json = localStorage.getItem('companyActivity');
  const companyActivity = json !== null ? JSON.parse(json) : [];
  if (activity === 'View') return companyActivity.map((o) => o.CompanyCode);
  else return companyActivity.filter((o) => o.Activity === 'Edit').map((o) => o.CompanyCode);
}
export function getShippingPointActivity(activity) {
  const json = localStorage.getItem('shippingPointActivity');
  const shippingPointActivity = json !== null ? JSON.parse(json) : [];
  if (activity === 'View') return shippingPointActivity.map((o) => o.ShippingPoint);
  else return shippingPointActivity.filter((o) => o.Activity === 'Edit').map((o) => o.ShippingPoint);
}

export function getRoleActivity(page) {
  const roleActivity = JSON.parse(localStorage.getItem('roleActivity'));
  return roleActivity.find((o) => o.PageName === page)?.Authorize ?? PageActivity.No;
}

export function checkCompanyEdit(list) {
  const companyEdit = getCompanyActivity(CompanyAuthorize.Edit);
  const com = list.find((f) => !companyEdit.includes(f.companyCode) && f.companyCode !== null && f.companyCode !== '');
  return {
    fail: com && !companyEdit.some((o) => o === 'all'),
    companyCode: com?.companyCode
  };
}

export function checkCompanyAndShippingPointEdit(list) {
  const companyEdit = getCompanyActivity(CompanyAuthorize.Edit);
  const shippingPointEdit = getShippingPointActivity(CompanyAuthorize.Edit);

  const com = list.find((f) => !companyEdit.includes(f.companyCode) && f.companyCode !== null && f.companyCode !== '');
  const ship = list.find(
    (f) => !shippingPointEdit.includes(f.shippingPoint) && f.shippingPoint !== null && f.shippingPoint !== ''
  );
  return {
    fail: (com && !companyEdit.some((o) => o === 'all')) || (ship && !shippingPointEdit.some((o) => o === 'all')),
    companyCode: com?.companyCode,
    shippingPoint: ship?.shippingPoint
  };
}

export function isEditCompanyAndShippingPoint(companyCode, shippingPoint) {
  const companyEdit = getCompanyActivity(CompanyAuthorize.Edit);
  const shippingPointEdit = getShippingPointActivity(CompanyAuthorize.Edit);
  return (
    (companyEdit.some((o) => o === 'all') || companyEdit.includes(companyCode)) &&
    (shippingPointEdit.some((o) => o === 'all') || shippingPointEdit.includes(shippingPoint))
  );
}

export function isViewCompany(companyCode) {
  const companyEdit = getCompanyActivity(CompanyAuthorize.View);
  return companyEdit.some((o) => o === 'all') || companyEdit.includes(companyCode);
}

export function isEditCompany(companyCode) {
  const companyEdit = getCompanyActivity(CompanyAuthorize.Edit);
  return companyEdit.some((o) => o === 'all') || companyEdit.includes(companyCode);
}

export function isEditMultipleCompany(companyCodes) {
  const companyEdit = getCompanyActivity(CompanyAuthorize.Edit);
  return (
    companyEdit.some((o) => o === 'all') ||
    !companyCodes ||
    companyEdit.some((o) => companyCodes.split(',').includes(o))
  );
}

export function isEditShippingPoint(shippingPoint) {
  const shippingPointEdit = getShippingPointActivity(CompanyAuthorize.Edit);
  return shippingPointEdit.some((o) => o === 'all') || shippingPointEdit.includes(shippingPoint);
}

export function isRoleSales() {
  const data = localStorage.getItem('isSales');
  return data === 'true';
}

export function isRoleOutsource() {
  const data = localStorage.getItem('isOutsource');
  return data === 'true';
}

export function isFactoring() {
  const data = localStorage.getItem('isFactoring');
  return data === 'true';
}

export function isSendEmailOverdue() {
  const data = localStorage.getItem('isSendEmailOverdue');
  return data === 'true';
}

export function isWithDrawOverdue() {
  const data = localStorage.getItem('isWithDrawOverdue');
  return data === 'true';
}

export function clearLocalStorageExceptWs() {
  Object.keys(localStorage).forEach((key) => {
    if (!key.startsWith('wc') && key !== 'i18nextLng') {
      localStorage.removeItem(key);
    }
  });
}
export function toScgStatus(status) {
  const statusLower = (status || '').toLowerCase();
  if (!status) return null;
  let color = 'default';
  if (['waiting'].indexOf(statusLower) >= 0) color = 'warning';
  if (['confirm'].indexOf(statusLower) >= 0) color = 'success2';
  if (['add'].indexOf(statusLower) >= 0) color = 'info';
  if (['delete'].indexOf(statusLower) >= 0) color = 'default';
  return <MChip key={status} label={status} color={color} />;
}

export function toCallingStatus(value, label) {
  const statusLower = (value || '').toLowerCase();
  if (!value) return null;
  let color = 'default';
  if (['waitforcf'].indexOf(statusLower) >= 0) color = 'warning';
  if (['sent'].indexOf(statusLower) >= 0) color = 'success2';
  if (['confirm'].indexOf(statusLower) >= 0) color = 'info';
  if (['failed', 'sendfailed'].indexOf(statusLower) >= 0) color = 'error';
  return <MChip key={value} label={label} color={color} />;
}

function validateDateType(dateType) {
  const allowedTypes = ['ValueDate', 'SAPBilling', 'Invoice Date', 'YBill', 'YCol', 'YCal', 'Document Date'];
  if (!dateType || dateType.length === 0) return false;
  return dateType.some((type) =>
    allowedTypes.some((x) => x.replace(' ', '').toLowerCase() === type.value?.replace(' ', '').toLowerCase())
  );
}

function validateDateFrom(dateType, dateValues) {
  // // ถ้าไม่ได้เลือก type เลย → ถือว่าไม่ผิด
  if (!dateType || dateType.length === 0) return true;

  // ถ้าเลือก type แล้ว แต่ไม่ได้กรอกวันที่เลย → ถือว่า "ผิด"
  if (!dateValues || dateValues.length === 0 || !dateValues[0]) {
    return false;
  }

  // // เลือก type แล้ว และมีวันที่ → ไม่ผิด
  return true;
}
function validateDateRange(dateType, dateValues, diffMonth) {
  if (!dateType || dateType.length === 0) return true;

  if (dateValues.length > 1 && dateValues[0] && dateValues[1]) {
    const diff = differenceInMonths(dateValues[1], dateValues[0]);
    return diff <= diffMonth;
  }
  return true;
}
function validateDocumentNo(documentType, documentNo) {
  if (!documentType || documentType.length === 0) return true;
  return !(documentType && documentType.length > 0 && !documentNo);
}

function allowDocumentType(documentType) {
  const allowedTypes = [
    'invoiceno',
    'invoice',
    'dp',
    'dpno',
    'billpresentmentno',
    'receiptno',
    'transactionno',
    'coversheetems',
    'chequeno',
    'documentno',
    'clearingdocno',
    'reportno',
    'documentnumber',
    'assignment',
    'chequereturnno',
    'latechargeno',
    'requestcancelcreditblockno',
    'overduereportno',
    'invoicenozf2',
    'invoicenozf8',
    'invoicenozf9',
    'eo',
    'pi',
    'sappi',
    'sapeo',
    'sapbilling',
    'sapinvoice',
    'billingno'
  ];
  if (!documentType || documentType.length === 0) return false;
  const typesArray = Array.isArray(documentType) ? documentType : [documentType];
  return typesArray.some((type) =>
    allowedTypes.some((x) => x.replace(' ', '').toLowerCase() === type.value.replace(' ', '').toLowerCase())
  );
}

export function requireSearchOS(params, isValidateDateType = true, diffMonth = 3) {
  const {
    companyCode,
    salesOrg,
    // selectTypeDate,
    // selectDate,
    selectTypeDate1,
    selectDate1,
    selectTypeDate2,
    selectDate2,
    selectTypeDate3,
    selectDate3,
    documentType,
    documentNoFrom,
    documentType1,
    documentNoFrom1,
    documentType2,
    documentNoFrom2
  } = params;

  if (
    !validateDateFrom(selectTypeDate1, selectDate1) ||
    !validateDateFrom(selectTypeDate2, selectDate2) ||
    !validateDateFrom(selectTypeDate3, selectDate3) // ||
    // !validateDateFrom(selectTypeDate, selectDate)
  ) {
    return `Please fill at least in "Select Date From". Otherwise, filling in between From - To is for interval data searching.`;
  }
  if (
    !validateDateRange(selectTypeDate1, selectDate1, diffMonth) ||
    !validateDateRange(selectTypeDate2, selectDate2, diffMonth) ||
    !validateDateRange(selectTypeDate3, selectDate3, diffMonth) // ||
    // !validateDateRange(selectTypeDate, selectDate)
  ) {
    return `Please select date range must not exceed ${diffMonth} months.`;
  }
  if (
    !validateDocumentNo(documentType1, documentNoFrom1) ||
    !validateDocumentNo(documentType2, documentNoFrom2) ||
    !validateDocumentNo(documentType, documentNoFrom)
  ) {
    return 'Please fill at least in "Document No. From". Otherwise, filling in between From - To is for interval data searching.';
  }

  if (!allowDocumentType(documentType1) && !allowDocumentType(documentType2) && !allowDocumentType(documentType)) {
    if ((!companyCode || companyCode.length === 0) && (!salesOrg || salesOrg.length === 0)) {
      return 'Please select Company Code or Sales Org.';
    }

    if (
      isValidateDateType &&
      selectTypeDate1 &&
      selectTypeDate1.length === 0 &&
      (selectTypeDate2 === undefined || (selectTypeDate2 && selectTypeDate2.length === 0)) &&
      (selectDate3 === undefined || (selectTypeDate3 && selectTypeDate3.length === 0)) // &&
      // selectTypeDate &&
      // selectTypeDate.length === 0
    ) {
      return 'Please Select Date.';
    }

    // if (
    //   isValidateDateType &&
    //   !validateDateType(selectTypeDate1) &&
    //   !validateDateType(selectTypeDate2) &&
    //   !validateDateType(selectTypeDate3) &&
    //   !validateDateType(selectTypeDate)
    // ) {
    //   return `Please select ${msg}.`;
    // }
  }
  return null;
}
